import { PerspectiveEnum } from '@/store/types'
import * as THREE from 'three'
let camera_distance = 70
let camera_azimuthalAngle_vehicle = Math.PI
let camera_polarAngle_vehicle = Math.PI / 4
let cameraPerspectiveAuto = true
export function initOrbit(perspectiveEnum, vehicleData) {
    switch (perspectiveEnum) {
        case PerspectiveEnum.side:
            camera_distance = 70;
            camera_azimuthalAngle_vehicle = Math.PI * 1.5
            camera_polarAngle_vehicle = Math.PI / 4
            cameraPerspectiveAuto = true
            break;
        case PerspectiveEnum.overlook:
            camera_distance = 70;
            camera_azimuthalAngle_vehicle = Math.PI * 1.5
            camera_polarAngle_vehicle = 0.1
            cameraPerspectiveAuto = true
            break;
        default:
            // camera_distance=70;
            // camera_azimuthalAngle_vehicle = Math.PI * 1.5
            // camera_polarAngle_vehicle = 0.1
            // cameraPerspectiveAuto=false;

            // let rotaZ = 1.5 * Math.PI - vehicleData.vehicle.orientation.z
            // let x = 2 * Math.sin(rotaZ)
            // let y = 2 * Math.cos(rotaZ)
            // camera.position.set(origin.x + x, origin.y + y, camera_distance)
            // controls.enablePan = true
            // controls.enableRotate = false
            // controls.mouseButtons = {
            //     LEFT: THREE.MOUSE.PAN,
            //     MIDDLE: THREE.MOUSE.DOLLY,
            //     RIGHT: THREE.MOUSE.PAN
            // }
            break;
    }
}
export const setCameraPerspective = (vehicleData, controls, camera, perspectiveStatus,scene) => {
    if (perspectiveStatus != PerspectiveEnum.free) {
        controls.target.set(vehicleData.origin.x, vehicleData.origin.y, scene.position.z)
        if (controls.enableRotate && cameraPerspectiveAuto) {
            let z = camera_distance * Math.cos(camera_polarAngle_vehicle)
            let r_xy = camera_distance * Math.sin(camera_polarAngle_vehicle)
            let x = r_xy * Math.sin(camera_azimuthalAngle_vehicle + vehicleData.vehicle.orientation.z)
            let y = -r_xy * Math.cos(camera_azimuthalAngle_vehicle + vehicleData.vehicle.orientation.z)
            if (camera.cameraPerspectiveAuto) {
                camera.position.set(vehicleData.origin.x + x, vehicleData.origin.y + y, scene.position.z + z)
            }
        }
    }
}
export function saveOribitChange(controls, vehicle_rotation) {
    if (!vehicle_rotation) {
        return
    }
    camera_distance = controls.getDistance();
    camera_azimuthalAngle_vehicle = controls.getAzimuthalAngle() - vehicle_rotation.z;
    camera_polarAngle_vehicle = controls.getPolarAngle();
}
export function set_cameraPerspectiveAuto(value, camera) {
    cameraPerspectiveAuto = value;
    camera.cameraPerspectiveAuto = value;
}

export function set_camera_free(vehicleData, controls, camera, perspectiveStatus,scene) {
    // if (store.state.perspective.type === PerspectiveEnum.free) {
    if (perspectiveStatus === PerspectiveEnum.free) {
        let rotaZ = 1.5 * Math.PI - vehicleData.vehicle.orientation.z
        let x = 2 * Math.sin(rotaZ)
        let y = 2 * Math.cos(rotaZ)
        camera.position.set(vehicleData.origin.x + x, vehicleData.origin.y + y, scene.position.z + 70)
        controls.enablePan = true
        controls.enableRotate = false
        controls.mouseButtons = {
            LEFT: THREE.MOUSE.PAN,
            MIDDLE: THREE.MOUSE.DOLLY,
            RIGHT: THREE.MOUSE.PAN
        }
        controls.target.set(vehicleData.origin.x, vehicleData.origin.y, scene.position.z)
    }
}